import { Flex } from '@chakra-ui/react';
import { DisplayFieldFromForm } from 'src/components/shared/DisplayField';
import {
  IPeerReviewFirstAssessment,
  IPeerReviewRevisionAssessment
} from '@publishing-engine/domain/models';

interface Props {
  review: IPeerReviewFirstAssessment | IPeerReviewRevisionAssessment;
  reviewFieldConfig: any;
}

const OptInsReivew: React.FC<Props> = ({ review, reviewFieldConfig }) => {
  const reviewAssessment = review as Record<string, any>;

  return (
    review && (
      <Flex direction="column" gap={4}>
        {'webOfScienceOptIn' in review && (
          <DisplayFieldFromForm
            formValues={reviewAssessment}
            formConfigs={reviewFieldConfig}
            configField="webOfScienceOptIn"
            valueField="webOfScienceOptIn"
          />
        )}
        {'peerReviewTransparency' in review && (
          <DisplayFieldFromForm
            formValues={reviewAssessment}
            formConfigs={reviewFieldConfig}
            configField="peerReviewTransparency"
            valueField="peerReviewTransparency"
          />
        )}
        {'reviewerAnonymity' in review && (
          <DisplayFieldFromForm
            formValues={reviewAssessment}
            formConfigs={reviewFieldConfig}
            configField="reviewerAnonymity"
            valueField="reviewerAnonymity"
          />
        )}
        {'receiveFeedback' in review && (
          <DisplayFieldFromForm
            formValues={reviewAssessment}
            formConfigs={reviewFieldConfig}
            configField="receiveFeedback"
            valueField="receiveFeedback"
          />
        )}
      </Flex>
    )
  );
};

export default OptInsReivew;
